<div class="wrapper flex flex-col">
  <div class="heading text-type-2">Issues</div>
  @if (data?.closed_at) {
    <div class="sub-heading">
      Closed by {{ name }} on {{ data?.closed_at | dateFormat:'long' }}, {{ data?.closed_at | dateFormat:'time' }}
    </div>
  }
  <!--
    Contractor workflow (projects with issue_workflow_enabled): the panel lays
    the issue out like the punch list item detail — a Details tab with the
    stage, this form and the action pick list, and a Discussion tab. Anywhere
    else it renders the form as it is.
  -->
  <app-issue-workflow-panel
    (actionActiveChange)="workflowActionActive = $event"
    (issueChanged)="onWorkflowChange($event)"
    (issueLoaded)="onWorkflowIssueLoaded($event)"
    (tabChange)="workflowTabIndex = $event"
    [issue]="data"
    >
    <app-issue-details-form
      [data]="data"
      (saveBarVisibleChange)="saveBarVisible = $event"
      [isMarkerClick]="isMarkerClick"
      class="issue-form"
      />
  </app-issue-workflow-panel>
  <!--
    The Save bar belongs to the Details tab (workflowTabIndex stays 0 off the
    workflow), and gives way to the workflow's Submit while an action is picked.
    On the workflow it is hidden for users who cannot edit the issue.
  -->
  <app-actions-section
    [disableOptionMenu]="disableOptionMenu"
    [hidden]="isMarkerClick || workflowTabIndex !== 0 || workflowActionActive || !saveBarVisible"
    [hideDeleteOption]="hideDeleteOption"
    class="actions-section w-[455px]"
    />
</div>
